import React, { useState } from 'react';
import { Content, CriticalButton, IconDiv } from './styles';
import TrendDown from '../../../assets/icons/TrendDown';
import Help from './HelpDialog';
import CriticalDialog from './CriticalDialog';
import { handleValidation } from '../../../pages/FlowPane/utils';

const Critical = ({
  elements,
  critical,
  setCritical = () => console.log('critical'),
  value,
  selectFlow,
  setIsSelectable,
}) => {
  const [help, setHelp] = useState(false);

  async function clearSelectable() {
    await selectFlow([]);
    await setIsSelectable(true);
  }

  const validation = () => handleValidation(elements);

  return (
    <>
      <Content>
        <CriticalButton
          critical={critical}
          onClick={() => {
            clearSelectable().then(() => {
              if (!critical) {
                if (validation()) setCritical();
              } else {
                setCritical();
              }
            });
          }}
        >
          <IconDiv critical={critical}>
            <TrendDown />
          </IconDiv>
        </CriticalButton>
        {help && <Help setHelp={() => setHelp(false)} />}
        {critical && value && (
          <CriticalDialog value={value} setCritical={setCritical} />
        )}
      </Content>
    </>
  );
};

export default Critical;
